import { apiSlice as api } from "./rtk-api/apiSlice"

const injectedRtkApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getMe: builder.query<IGetMeResponse, void>({
      query: () => ({
        url: `/v1/user`,
        method: "GET",
      }),
    }),
    updateMe: builder.mutation<IUpdateUserResponse, IUpdateUserRequest>({
      query: (data) => ({
        url: `/v1/user`,
        method: "PATCH",
        data,
      }),
    }),
    deleteMe: builder.mutation<{ success: boolean; error?: string }, void>({
      query: () => ({
        url: `/v1/user`,
        method: "DELETE",
      }),
    }),
  }),
})

export const { useGetMeQuery, useLazyGetMeQuery, useUpdateMeMutation, useDeleteMeMutation } = injectedRtkApi

export default injectedRtkApi

interface IGetMeResponse {
  success: boolean
  error?: string
  session?: {
    tenantId: string | null
    authenticator?: { enabled: boolean }
    organizationSetup?: {
      complete: boolean
      /** `type` is set by an admin; MUNICIPALITY shows the municipality sidebar (MPE-988). */
      organization: { name: string; countryCode: string | null; type?: string } | null
    }
  }
  user: {
    id: string
    email: string
    firstName: string
    lastName: string
    image: string
    jobTitle: string | null
  }
}

export interface IUpdateUserRequest {
  firstName?: string
  lastName?: string
  email?: string
  jobTitle?: string
  image?: string
}

export interface IUpdateUserResponse {
  success: boolean
  error?: string
}
